import React from 'react';

const marker = (
	<>
		<g strokeWidth="1" transform="translate(8.000000, 8.000000)" fill="#A70066">
			<rect x="0" y="0" width="16" height="16" rx="8"/>
		</g>
		<path
			d="M14.3574003,11.2910773 L18.005869,12.9209042 L17.2495441,15.4402118 L16.0830994,17.4700387 L17.0737785,17.4700387 L17.9153231,15.9941399 L18.6130594,16.31904 L17.867387,17.6719029 L18.8314349,17.6719029 L19.3800368,16.6812238 L19.7901566,16.8729681 C20.0830994,17.0061239 20.2854962,17.2724355 20.3334323,17.5920094 L20.3334323,17.5920094 L20.5677864,19.0833543 L12.5677864,19.0833543 L12.5890914,16.6013303 L13.0547864,15.2010773 L13.909785,15.529318 L14.2169575,14.7291062 L13.3257864,14.3870773 L13.5217864,13.7990773 L15.0526421,14.3864609 L15.3598146,13.5862491 L13.7927864,12.9850773 L14.3574003,11.2910773 Z"
			fill="#FFFFFF"/>
	</>
);

const RentMarkers = () => (
	<g id="rentMarkers" transform="translate(1101.000000, 844.000000)">
		<g transform="translate(188.000000, 24.000000)">{marker}</g>

		<g transform="translate(343.000000, 139.000000)">{marker}</g>
		<g transform="translate(15.000000, 214.000000)">{marker}</g>

		<g transform="translate(368.000000, 0.000000)">{marker}</g>
		<g transform="translate(458.000000, 103.000000)">{marker}</g>

		<g transform="translate(270, -50)">{marker}</g>
		<g transform="translate(370, 80)">{marker}</g>
		<g transform="translate(385, 115)">{marker}</g>
		<g transform="translate(408, 235)">{marker}</g>
		<g transform="translate(395, 373)">{marker}</g>
	</g>
);

export default RentMarkers;
